// hub8020/src/components/feed/EventCard.js
import { Box, Text, Image, HStack } from '@chakra-ui/react';
import moment from 'moment';
import { TimeIcon } from '@chakra-ui/icons';
import { useNavigate } from 'react-router-dom';
import { MdLocationOn } from 'react-icons/md';

const EventCard = ({ event }) => {
  const navigate = useNavigate();

  if (!event) return null;

  const viewEvent = () => {
    navigate(`../events`);
  };

  return (
    <Box className="w-full border border-gray-200 rounded-xl bg-white p-4 shadow-sm cursor-pointer">
      {event.cover_image ? (
        <Image
          src={event.cover_image}
          alt={event.name}
          width="100%"
          objectFit="cover"
          borderRadius="md"
          mb={4}
          className="h-[150px]"
        />
      ) : (
        <Box
          bg="blue.100"
          h="150px"
          w="100%"
          borderRadius="md"
          mb={4}
          display="flex"
          alignItems="center"
          justifyContent="center"
        ></Box>
      )}
      <Text fontWeight="bold" fontSize="lg" mb={2}>
        {event.name}
      </Text>

      <HStack spacing={2}>
        <TimeIcon color="gray.500" />
        <Text color="gray.500" className="text-sm md:text-base">
          {moment(event.start_date).format('MMM D, YYYY h:mm A')} -{' '}
          {moment(event.end_date).format('MMM D, YYYY h:mm A')}
        </Text>
      </HStack>

      <HStack spacing={2}>
        <MdLocationOn />
        <Text color="gray.600" className="text-sm md:text-base">
          {event.location}
        </Text>
      </HStack>

      <Text
        fontSize="sm"
        noOfLines={2}
        mb={3}
        textOverflow="ellipsis"
        className="event_card"
        flex="1"
      >
        {event?.description}
      </Text>

      <button
        onClick={viewEvent}
        className="bg-blue-100 text-blue-700 font-semibold px-4 py-2 rounded-lg text-sm hover:bg-blue-200 transition"
      >
        <span className="font-medium">View Event</span>
      </button>
    </Box>
  );
};

export default EventCard;
